import { graphql } from 'react-relay';

const updateVueCommunicationMutation = graphql`
  mutation UpdateVueCommunicationMutation(
    $communicationId: ID!
    $heading: String!
    $message: String!
    $first: Int!
  ) {
    updateVueCommunication (
      communicationId: $communicationId
      heading: $heading
      message: $message
    ){
      vue {
        vuecommunicationSet (
          orderBy: "-createdAt"
          first: $first
        )
        {
          edges {
            node {
              id
              heading
              message
              published
              publishedAt
              createdAt
              updatedAt
            }
          }
        }
      }
    }
  }
`;
export default updateVueCommunicationMutation;
